export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "main.worker.1113873.worker.js");
}
